import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import getOwfTOSArticleData from "@faire/web-api--source/api/small-business-grant/tos-info/get";
export var getOwfGrantTOSArticleData = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function() {
        var _data_terms_of_service_article, _data_terms_of_service_article1, data, _data_terms_of_service_article_id;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getOwfTOSArticleData()
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        {
                            linkOrId: (_data_terms_of_service_article_id = (_data_terms_of_service_article = data.terms_of_service_article) === null || _data_terms_of_service_article === void 0 ? void 0 : _data_terms_of_service_article.id) !== null && _data_terms_of_service_article_id !== void 0 ? _data_terms_of_service_article_id : "",
                            locale: (_data_terms_of_service_article1 = data.terms_of_service_article) === null || _data_terms_of_service_article1 === void 0 ? void 0 : _data_terms_of_service_article1.zendesk_locale
                        }
                    ];
            }
        });
    });
    return function getOwfGrantTOSArticleData() {
        return _ref.apply(this, arguments);
    };
}();
